export default __webpack_public_path__ + "static/media/Dashboards.08dd4833.md";